import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { DisputeService, DisputeTypeService } from "../../services";
import { asQuery } from "../../services/common";
import { ONE_HOUR, AD_STALE, DASH_STALE } from "./shared";

// Dispute types (reference data, token-gated) for the dispute form dropdown.
export function useDisputeTypes(token?: string) {
  return useQuery({
    queryKey: ["dispute-types", token],
    queryFn: () =>
      asQuery<any[]>(DisputeTypeService.all(token as string, { keyword: "" })),
    enabled: !!token,
    staleTime: ONE_HOUR,
  });
}

// Whether the signed-in user has an active dispute on this ad (token-gated).
export function useActiveDispute(adId?: string, token?: string) {
  return useQuery({
    queryKey: ["disputes", "active", adId, token],
    queryFn: () =>
      asQuery<any>(DisputeService.hasActive(token as string, { adId })),
    enabled: !!adId && !!token,
    staleTime: AD_STALE,
  });
}

// Paginated "My Disputes" dashboard table ({ list, count }).
export function useMyDisputes(token: string | undefined, params: any) {
  return useQuery({
    queryKey: ["disputes", "mine", token, params],
    queryFn: () => asQuery<any>(DisputeService.getMine(token as string, params)),
    enabled: !!token,
    staleTime: DASH_STALE,
    placeholderData: keepPreviousData,
  });
}
